// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"4e45d4cc","276":"2c980c40","725":"be8cc093","779":"311c6fb3","941":"974e5598"}[chunkId] + ".chunk.css";
};